import Vue from "vue";
import Router from "vue-router";
import { AppPageNotFound } from "./shared/components";
import { Dashboard } from "./dashboard/index";
import { ValidateLink } from "./dashboard/index";
import { Confirm } from "./assigningPoints/index";
import { AssignManager } from "./assigningPoints/index";
import { AssignPoints } from "./assigningPoints/index";
import { PaymentProcessed } from './shared/components';
import { Profile } from './profile/index';
import { Transactions } from './transactions/index';
import { Receipt} from './transactions/index';

Vue.use(Router);

const appRoutes = [
  {
    path: "/",
    name: 'stores',
    component: Dashboard
  },  
  {
    path: "/funding",
    name: 'login',
    component: ValidateLink,
  },
  {
    path: "/assign/select-manager/:code?",
    component: AssignManager,
    name: 'managers'
  },
  {
    path: "/assign/assign-points/:code?",
    component: AssignPoints,
    name: 'points'
  },
  {
    path: "/assign/confirm/:transactionId?",
    component: Confirm,
    name: 'transaction'
  },
   {
    path: "/success/:transactionId",
    component: PaymentProcessed,
    name: 'success'
  },
  {
    path: "*",
    name: "page-not-found",
    component: AppPageNotFound,
  },
  {
    path: "/profile",
    name: 'Profile',
    component: Profile,
  },
  {
    path: "/transactions",
    name: 'tranasctionList',
    component: Transactions,
  },
  {
    path: "/transactions/:id?",
    name: 'transactionDetail',
    component: Receipt,
  },
];

const routes = [...appRoutes];

export default new Router({
  mode: "history",
  routes,
});
